/**
 * Finds the first index which is a duplicate value
 * Returns null if there are no duplicates
 * Returns the index of the first duplicate entry it finds
 */
export const findDuplicateIndex = <T> (arr: Array<T>, value: T): number | null => {
  const [ ,indexFound] = arr.reduce((
    prev,
    currentValue,
    currentIndex,
  ) => {
    if (currentValue === value) {
      prev.push(currentIndex);
    }
    return prev;
  }, [] as number[]);
  return indexFound !== undefined && indexFound >= 0 ? indexFound : null;
};
